module.exports = __webpack_public_path__ + "static/img/Usariosinimagen.6a63d6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Usariosinimagen.png
// module id = b4ci
// module chunks = 0